import { Resource } from 'src_common/common/mobx-utils/Resource';
import { makeAutoObservable } from 'mobx';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { pepAndSanctionsXml } from 'src_server/types';
import addError from 'src/utils/error.jsx';

export class PepXmlState {
    public isLoading: boolean;
    private readonly xmlResponse: Resource<pepAndSanctionsXml.TResponseType | null>;

    public constructor(
        private readonly trpcClient: TrpcClient,
        private readonly accountId: () => number | null
    ) {
        this.isLoading = true;

        this.xmlResponse = new Resource(async (): Promise<pepAndSanctionsXml.TResponseType | null> => {
            const accountId = this.accountId();
            if (accountId === null) {
                return null;
            }

            return this.handleXMLRequest(accountId);
        });
        makeAutoObservable(this);
    }

    private setLoading(isLoading: boolean): void {
        this.isLoading = isLoading;
    }

    private handleXMLRequest = async (accountId: number): Promise<pepAndSanctionsXml.TResponseType | null> => {
        let response = null;
        try {
            response = await this.trpcClient.client.pepAndSanctions.getXmlTransUnion.query({ accountId });
        } catch (error) {
            response = null;
            addError('Failed to fetch XML details');
        } finally {
            this.setLoading(false);
        }
        return response;
    };

    public get xmlData(): pepAndSanctionsXml.TResponseType | null {
        const result = this.xmlResponse.get();

        if (result.type === 'ready') {
            return result.value;
        }

        return null;
    }
}
